import getConfigs from './ws/getConfigs';
import updateConfigs from './ws/updateConfigs';

const invoiceService = {
	getConfigs,
	updateConfigs,
};

export default invoiceService;